// extracted by mini-css-extract-plugin
export default {"taskTemplatesRow":"taskTemplatesRow---jX2_4","taskTemplatesCell":"taskTemplatesCell---XlVaf","taskTemplatesBorderedCol":"taskTemplatesBorderedCol---lefx_"};